// LugaresEventoAction.js
import HttpCliente from '../HttpCliente';

/**
 * GET method - Obtiene la lista paginada de Lugares de Evento
 * @param {Function} setLugares función para establecer la lista de lugares
 * @param {Function} setError función para establecer el estado de error
 * @param {Number} page número de página
 * @param {Number} pageSize tamaño de página
 * @param {String} searchTerm término de búsqueda opcional
 * @param {String} token token de autenticación
 * @return {Promise} Promesa de obtención
 */
export const getLugaresPaginados = (setLugares, setError, page = 1, pageSize = 5, searchTerm = "", token) => {
    return new Promise((resolve, reject) => {
        let url = `/LugarEvento/paged?pageNumber=${page}&pageSize=${pageSize}`;
        if (searchTerm) {
            url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
        }

        HttpCliente.get(url, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setLugares(response.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * GET method - Obtiene un Lugar de Evento por ID
 * @param {String} id ID del lugar
 * @param {Function} setLugar función para establecer el lugar
 * @param {Function} setError función para establecer el estado de error
 * @param {String} token token de autenticación
 * @return {Promise} Promesa de obtención
 */
export const getLugarById = (id, setLugar, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/LugarEvento/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setLugar(response.data.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * POST method - Crea un nuevo Lugar de Evento
 * @param {Object} lugarData datos del nuevo lugar
 * @param {Function} setError función para establecer el estado de error
 * @param {String} token token de autenticación
 * @return {Promise} Promesa de creación
 */
export const createLugar = (lugarData, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/LugarEvento", lugarData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 201 || response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * PATCH method - Cambia el estado (habilitar/deshabilitar) de un Lugar de Evento
 * @param {String} id ID del lugar
 * @param {Function} setError función para establecer el estado de error
 * @param {String} token token de autenticación
 * @return {Promise} Promesa de cambio de estado
 */
export const toggleLugarStatus = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.patch(`/LugarEvento/${id}/toggle-status`, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * PUT method - Actualiza un Lugar de Evento existente
 * @param {String} id ID del lugar a actualizar
 * @param {Object} lugarData datos actualizados del lugar
 * @param {Function} setError función para establecer el estado de error
 * @param {String} token token de autenticación
 * @return {Promise} Promesa de actualización
 */
export const updateLugar = (id, lugarData, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/LugarEvento/${id}`, lugarData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};